import { format } from 'd3-format';
export default format('$,.2f');
